/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge16 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							min-width: 700px;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])
	return <div className={`w-100 flex-centered edge-${id}  delimiter-edge-16`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		>  
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M52.5,23.2c-0.2-0.4-0.4-0.9,0-1.3c0.5-0.4,1-0.3,1.5-0.1c1.2,0.7,2.5,1.2,3.5,2.2c1.1,1.2,2.4,0.7,3.7,0.7
				c-0.1-0.7-0.5-0.8-0.8-1.1c-0.3-0.2-0.6-0.4-0.9-0.7c-0.3-0.3-0.4-0.8-0.1-1.2c0.3-0.4,0.7-0.5,1.1-0.2c0.7,0.5,1.4,1,2.1,1.4
				c0.7,0.4,1.3,0.9,2,1.3c0.5,0.3,1.1,0.6,1.9,0.3c-0.4-1.2-2-1.3-2.2-2.5c0.2-0.7,0.7-0.9,1.2-0.6c0.5,0.2,1,0.4,1.4,0.8
				c0.8,0.7,1.7,1.2,2.4,1.8c0.9,0.7,1.8,0.8,2.9,0.6c-0.8-1.2-2.9-1.2-2.9-3c0.6-0.6,1.2-0.4,1.7-0.1c1.3,0.9,2.8,1.5,3.9,2.8
				c0.4,0.5,0.9,0.5,1.4,0.3c0.4-0.3,0.4-0.7,0.6-1.1c0.2-0.4,0.3-0.8,0.8-0.8c0.5,0,0.7,0.4,0.8,0.9c0,0.1,0,0.2,0,0.3
				c0.1,0.5,0.3,0.8,0.8,0.9c0.6,0.1,0.9-0.2,1.1-0.7c0.1-0.4,0.3-0.8,0.8-0.9c0.7,0.4,0.7,0.4,1,1.4c0.3,0.3,0.7,0.3,1,0.3
				c0.4,0,0.7,0,1.1,0c10.1,0.4,20.3,0.2,30.4,0.4c2.5,0,5.1,0,7.6,0.5c0.3,0,0.5,0,0.8,0c7.5,0,15.1,0.5,22.6,0.4
				c6.4-0.1,12.7-0.3,19.1-0.4c3.7-0.1,7.4-0.1,11.1-0.3c0.7,0,1.5-0.2,2.2-0.2c0.5,0,0.9-0.2,1.3-0.6c0.7-0.6,0.9-0.6,1.6,0.1
				c1,1,2,1,3,0c0.3-0.3,0.6-0.6,1.1-0.5c0.3,0.1,0.4,0.4,0.5,0.6c0.1,0.2,0.2,0.4,0.3,0.5c0.5,0.1,1,0.2,1.4,0.3
				c1.4,0.2,1.8-0.1,1.8-1.5c0-0.5-0.1-1.1-0.2-1.6c-0.1-0.8-0.1-1.6-0.1-2.4c0-0.4,0.1-0.7,0.5-1.1c4.1,2.2,8.3,4.4,11.9,7.3
				c0,0.8-0.6,1-1.1,1.3c-2.6,1.4-5,3-7.5,4.5c-0.9,0.6-1.7,1.4-2.8,1.8c-0.6-1.2-0.9-2.3-0.6-3.6c0.1-0.7,0.2-1.4,0.1-2.1
				c-0.1-0.9-0.3-1.1-1.2-1.2c-0.9,0-1.8-0.2-2.6,0.1c-0.5,0.4-0.3,0.8-0.5,1.2c-0.3,0.6-0.9,0.7-1.3,0.1c-0.3-0.4-0.5-0.9-0.7-1.4
				c-0.7-0.4-1.4-0.4-2.1-0.2c-0.5,0.5-0.3,1.2-0.3,1.7c-0.1,0.5-0.2,0.9-0.7,0.9c-0.4,0-0.7-0.3-0.8-0.7c-0.2-0.6-0.3-1.2-0.5-1.8
				c-0.5-0.5-1.2-0.3-1.7-0.3c-3.9,0.1-7.9,0.2-11.8,0.4c-3,0.2-6,0.1-9.1,0.2c-5.7,0.3-11.3,0.2-17,0.3c-4.3,0-8.7-0.3-13-0.5
				c-1.9-0.1-3.8,0.1-5.7-0.1c-7.8-0.6-15.7-0.1-23.5-0.4c-4.3-0.2-8.7-0.2-13-0.3c-0.7,0-1.5-0.1-2.2,0.1c-0.4,0.1-0.8,0-1.2-0.1
				c-0.5-0.2-1-0.3-1.5-0.1c-0.5,0.4-0.1,1.2-0.8,1.6c-1.1,0.2-1.1-1-1.6-1.5c-0.8-0.3-1.3,0-1.8,0.4c-1.2,1-2.7,1.5-4,2.2
				c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.3-0.1-0.6,0.1-0.9c0.4-0.6,1.1-0.8,1.7-1.3c-1-0.3-1.6-0.2-2.3,0.5
				c-1.1,1.1-2.5,1.8-3.8,2.6c-0.4,0.2-0.8,0.3-1.1-0.1c-0.3-0.4-0.1-0.8,0.2-1.1c0.4-0.4,0.8-0.7,1.2-1c0.3-0.3,0.9-0.4,1-1
				c-0.8-0.4-1.5-0.2-2.4-0.1c-0.9,1.7-2.8,2.3-4.2,3.5c-0.4,0.3-0.9,0.3-1.4-0.1c0-1.7,1.8-2,2.6-3.1c-1.3-0.8-2.2-0.6-3,0.5
				c-0.9,1.2-2.2,2-3.1,3.2c-0.2,0.3-0.6,0.3-0.9,0.1c-0.4-0.2-0.5-0.6-0.4-1c0.2-0.7,0.7-1.2,1.1-1.7c0.3-0.3,0.8-0.5,1.1-1.1
				c-1.1-0.3-2.1-0.5-3,0.4c-0.8,0.8-1.9,1.2-2.8,1.7c-0.3,0.2-0.7,0.2-1-0.2c-0.3-0.4-0.3-0.8,0.1-1.2c0.3-0.3,0.7-0.4,0.9-0.9
				c-0.4-0.3-0.9-0.2-1.4-0.2c-0.3,0-0.6,0-1,0c-0.6-0.1-1.1-0.2-1.1-0.9c0-0.7,0.5-0.8,1.1-0.9c0.7,0,1.4,0,2.1,0c0.3,0,0.6,0.1,1-0.3
				c-0.3-0.8-1.5-0.8-1.6-1.9c0.3-0.6,0.8-0.7,1.4-0.4C51.2,22.5,51.7,23.1,52.5,23.2c0.2,0.2,0.4,0.3,0.6,0.3l0.1,0.1l-0.1-0.1
				C53,23.3,52.7,23.2,52.5,23.2z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M426.1,23.2c0.2-0.4,0.4-0.9,0-1.3c-0.5-0.4-1-0.3-1.5-0.1c-1.2,0.7-2.5,1.2-3.5,2.2c-1.1,1.2-2.4,0.7-3.7,0.7
				c0.1-0.7,0.5-0.8,0.8-1.1c0.3-0.2,0.6-0.4,0.9-0.7c0.3-0.3,0.4-0.8,0.1-1.2c-0.3-0.4-0.7-0.5-1.1-0.2c-0.7,0.5-1.4,1-2.1,1.4
				c-0.7,0.4-1.3,0.9-2,1.3c-0.5,0.3-1.1,0.6-1.9,0.3c0.4-1.2,2-1.3,2.2-2.5c-0.2-0.7-0.7-0.9-1.2-0.6c-0.5,0.2-1,0.4-1.4,0.8
				c-0.8,0.7-1.7,1.2-2.4,1.8c-0.9,0.7-1.8,0.8-2.9,0.6c0.8-1.2,2.9-1.2,2.9-3c-0.6-0.6-1.2-0.4-1.7-0.1c-1.3,0.9-2.8,1.5-3.9,2.8
				c-0.4,0.5-0.9,0.5-1.4,0.3c-0.4-0.3-0.4-0.7-0.6-1.1c-0.2-0.4-0.3-0.8-0.8-0.8c-0.5,0-0.7,0.4-0.8,0.9c0,0.1,0,0.2,0,0.3
				c-0.1,0.5-0.3,0.8-0.8,0.9c-0.6,0.1-0.9-0.2-1.1-0.7c-0.1-0.4-0.3-0.8-0.8-0.9c-0.7,0.4-0.7,0.4-1,1.4c-0.3,0.3-0.7,0.3-1,0.3
				c-0.4,0-0.7,0-1.1,0c-10.1,0.4-20.3,0.2-30.4,0.4c-2.5,0-5.1,0-7.6,0.5c-0.3,0-0.5,0-0.8,0c-7.5,0-15.1,0.5-22.6,0.4
				c-6.4-0.1-12.7-0.3-19.1-0.4c-3.7-0.1-7.4-0.1-11.1-0.3c-0.7,0-1.5-0.2-2.2-0.2c-0.5,0-0.9-0.2-1.3-0.6c-0.7-0.6-0.9-0.6-1.6,0.1
				c-1,1-2,1-3,0c-0.3-0.3-0.6-0.6-1.1-0.5c-0.3,0.1-0.4,0.4-0.5,0.6c-0.1,0.2-0.2,0.4-0.3,0.5c-0.5,0.1-1,0.2-1.4,0.3
				c-1.4,0.2-1.8-0.1-1.8-1.5c0-0.5,0.1-1.1,0.2-1.6c0.1-0.8,0.1-1.6,0.1-2.4c0-0.4-0.1-0.7-0.5-1.1c-4.1,2.2-8.3,4.4-11.9,7.3
				c0,0.8,0.6,1,1.1,1.3c2.6,1.4,5,3,7.5,4.5c0.9,0.6,1.7,1.4,2.8,1.8c0.6-1.2,0.9-2.3,0.6-3.6c-0.1-0.7-0.2-1.4-0.1-2.1
				c0.1-0.9,0.3-1.1,1.2-1.2c0.9,0,1.8-0.2,2.6,0.1c0.5,0.4,0.3,0.8,0.5,1.2c0.3,0.6,0.9,0.7,1.3,0.1c0.3-0.4,0.5-0.9,0.7-1.4
				c0.7-0.4,1.4-0.4,2.1-0.2c0.5,0.5,0.3,1.2,0.3,1.7c0.1,0.5,0.2,0.9,0.7,0.9c0.4,0,0.7-0.3,0.8-0.7c0.2-0.6,0.3-1.2,0.5-1.8
				c0.5-0.5,1.2-0.3,1.7-0.3c3.9,0.1,7.9,0.2,11.8,0.4c3,0.2,6,0.1,9.1,0.2c5.7,0.3,11.3,0.2,17,0.3c4.3,0,8.7-0.3,13-0.5
				c1.9-0.1,3.8,0.1,5.7-0.1c7.8-0.6,15.7-0.1,23.5-0.4c4.3-0.2,8.7-0.2,13-0.3c0.7,0,1.5-0.1,2.2,0.1c0.4,0.1,0.8,0,1.2-0.1
				c0.5-0.2,1-0.3,1.5-0.1c0.5,0.4,0.1,1.2,0.8,1.6c1.1,0.2,1.1-1,1.6-1.5c0.8-0.3,1.3,0,1.8,0.4c1.2,1,2.7,1.5,4,2.2
				c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.6-0.1,0.8-0.4c0.2-0.3,0.1-0.6-0.1-0.9c-0.4-0.6-1.1-0.8-1.7-1.3c1-0.3,1.6-0.2,2.3,0.5
				c1.1,1.1,2.5,1.8,3.8,2.6c0.4,0.2,0.8,0.3,1.1-0.1c0.3-0.4,0.1-0.8-0.2-1.1c-0.4-0.4-0.8-0.7-1.2-1c-0.3-0.3-0.9-0.4-1-1
				c0.8-0.4,1.5-0.2,2.4-0.1c0.9,1.7,2.8,2.3,4.2,3.5c0.4,0.3,0.9,0.3,1.4-0.1c0-1.7-1.8-2-2.6-3.1c1.3-0.8,2.2-0.6,3,0.5
				c0.9,1.2,2.2,2,3.1,3.2c0.2,0.3,0.6,0.3,0.9,0.1c0.4-0.2,0.5-0.6,0.4-1c-0.2-0.7-0.7-1.2-1.1-1.7c-0.3-0.3-0.8-0.5-1.1-1.1
				c1.1-0.3,2.1-0.5,3,0.4c0.8,0.8,1.9,1.2,2.8,1.7c0.3,0.2,0.7,0.2,1-0.2c0.3-0.4,0.3-0.8-0.1-1.2c-0.3-0.3-0.7-0.4-0.9-0.9
				c0.4-0.3,0.9-0.2,1.4-0.2c0.3,0,0.6,0,1,0c0.6-0.1,1.1-0.2,1.1-0.9c0-0.7-0.5-0.8-1.1-0.9c-0.7,0-1.4,0-2.1,0c-0.3,0-0.6,0.1-1-0.3
				c0.3-0.8,1.5-0.8,1.6-1.9c-0.3-0.6-0.8-0.7-1.4-0.4C427.4,22.5,426.8,23.1,426.1,23.2c-0.2,0.2-0.4,0.3-0.6,0.3l-0.1,0.1l0.1-0.1
				C425.6,23.3,425.8,23.2,426.1,23.2z"/>
		</svg>
	</div>
}

